<template>
    <div class="ebcDTPage">
         <page-navigate></page-navigate>
        <div class="learning-center">
      <div class="container">
        <ul class="breadcrumb">
          <li><a href="/">首页</a></li>
          <li>
            <a :href="'/LearningCenter?'+learningCenterUrl">{{ article.category_name }}</a>
          </li>
          <li class="active">{{ article.post_title }}</li>
        </ul>
      </div>

      <div class="news-content container">
        <h1>{{ article.post_title }}</h1>
        <span class="time"
          >{{ ts2ymd(article.published_time) }}</span
        >
        <div class="abstract">
          <img class="bag_ar" src="@/assets/image/LearningCenter/summary.png" alt="" />
          <span class="abstract_name">摘要:</span>
          <p class="abstract_text">{{ article.post_excerpt }}</p>
        </div>
        <div class="info" v-html="article.post_content"></div>
        <div class="previous-next">
            <div class="previous" v-if="prev_article">
              <span>上一篇：</span>
              <a :href="'/ebcDT/'+prev_article.id">{{ prev_article.title }}</a>
            </div>
            <div class="next" v-if="next_article">
              <span>下一篇：</span>
              <a :href="'/ebcDT/'+next_article.id">{{ next_article.title }}</a>
            </div>
        </div>
      </div>
      <div class="tab-content">
        <ul class="nav nav-tabs container">
          <li class="active"><span>相关文章</span></li>
        </ul>
        <div class="tab-pane active container">
          <div class="row">
              <div class="col-lg-4 col-md-6 news-li" v-for="(item,index ) in related.list" :key="index">
                <div class="thumbnail">
                  <a :href="'/ebcDT/'+item.id"
                    ><img
                      :src="item.thumbnail"
                      :alt="item.post_title"
                  /></a>
                  <div class="caption">
                    <h3><a :href="'/ebcDT/'+item.id">{{ item.post_title }}</a></h3>
                    <p>{{item.post_excerpt}}</p>
                    <span>{{ ts2ymd(item.published_time) }}</span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
            <page-footer></page-footer>
    </div>
</template>
<script>
    import fadeAnimate from "../mixins/fadeAnimate.js";
    import moment from 'moment';

    export default{
        mixins: [fadeAnimate],
        created(){
            console.log(111)
            this.rId = this.$route.params.id 
            this.getPageData(this.rId)
        },
        data(){
            return{
                rId:'',
                article :'',
                next_article:'',
                prev_article:'',
                recommended:'',
                related:'',
                tabArr:['','对话EBC','福利活动','交易大赛','公告'],
                tab4SecondTab:['','交易时间','交易规则','系统通知','其他']
            }
        },
        computed:{
          learningCenterUrl(){
            const Tab4SecondIndex = this.tab4SecondTab.indexOf(this.article.category_name)
            const tabIndex = this.tabArr.indexOf(this.article.category_name)
            console.log(this.article.category_name,Tab4SecondIndex)

            if(Tab4SecondIndex>0){
              return `tab=4&&secondTab=`+Tab4SecondIndex
            }else {
              console.log(2222)
              return 'tab='+tabIndex
            }
          }
        },
        methods:{
             ts2ymd(ts) {
            return moment.unix(new Date(ts)).format("YYYY年MM月DD日")
        },
            getPageData(id){
                fetch(`https://academy.ebccfd.com/api/academy-detail?id=${id}`).then(res=>res.json()).then(data=>{
                    const { article, next_article, prev_article, recommended, related } = data.data
                    this.article = article;
                    this.next_article = next_article;
                    this.prev_article = prev_article;
                    this.recommended = recommended;
                    this.related = related;
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import url('../assets/css/news.css');
    .ebcDTPage{
        padding-top: 80px;
    }
    @media  (max-width:996px) {
         .ebcDTPage{
        padding-top: 0px;
    }
    }
</style>